
export interface NotificationTarget {
  /** @nullable */
  targetId?: number | null;
  /** @nullable */
  targetType?: string | null;
}
